import HeaderContent from "@shared/ui/header-content/header-content";
import "./activate-card.scss";
import { FaChevronLeft } from "react-icons/fa";
import { useActivateCard } from "./activate-card.hook";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import FormCardSeriesActivate from "../form-card-series-activate/form-card-series-activate";

/* eslint-disable-next-line */
export interface ActivateCardProps {}

export function ActivateCard() {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useActivateCard();

  return (
    <div id="ActivateCard" className="activate-card">
      <HeaderContent
        title={<h1>Activate Card</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Activate"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormCardSeriesActivate />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default ActivateCard;
